let languages: LanguageKey[] = ['fr', 'en'];
export const setLanguages = (langs: LanguageKey[]) => languages = langs;

export const getLanguages = () => languages;
